// lib
import React from 'react';

// container
import Register from '../containers/Account/Register';

export default {
  path: '/account',
  routes: [
    {
      path: '/register',
      sidebar: {
        hide: false,
        title: <span>用户注册</span>,
      },
      component: Register,
    },
  ]
};



// WEBPACK FOOTER //
// ./src/routes/account.jsx